import React, { useEffect, useState} from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'reactstrap';
import * as actions from '../actions/Jurisdictions';
import GridHeader from '../components/common/GridHeader';
import DeleteConfirmation from '../components/MultiDeleteConfirmation';
import Breadcrumb from '../components/AdminBreadcrumb';
import { DataGrid } from '@mui/x-data-grid';

const Jurisdictions = (props) => {
    const [deleteConfirmationState, setDeleteConfirmationState] = useState({
        display: false,
        toDelete: [],
    });
    const [deleteEnabled, setDeleteEnabled] = useState(false);

    useEffect(() => {
        props.actions.getJurisdictions();
    }, []);

    const handleSelect = (e) => {
        props.actions.getJurisdiction(e.id);
        props.history.push(`/jurisdictions/jurisdiction/${e.id}`, { id: e.id })
    };

    const handleNew = () => {
        props.actions.newJurisdiction();
        props.history.push('/jurisdictions/jurisdiction');
    }

    const handleDeleteClick = (e) => {
        setDeleteConfirmationState({
            display: true,
            toDelete: deleteConfirmationState.toDelete
        });
    }

    const handleSelectionChanged = (e) => {
        if (e.length > 0) {
            setDeleteConfirmationState({
                display: false,
                toDelete: props.jurisdictions.filter(x => e.find(y => y === x.get('jurisdictionId'))).toJS(),
            });
            setDeleteEnabled(true);
        }
        else
            setDeleteEnabled(false);
    }

    const handleDelete = () => {
        props.actions.deleteJurisdictions(deleteConfirmationState.toDelete.map(x => x.jurisdictionId));
        setDeleteConfirmationState({
            display: false,
            toDelete: [],
        });
    }

    const handleDeleteConfirmationToggle = () => setDeleteConfirmationState({
        display: !deleteConfirmationState.display,
        toDelete: deleteConfirmationState.toDelete
    });

        return (
            <Container>
                <div style={{ paddingBottom: '10px' }}>
                    <Breadcrumb history={props.history} />
                </div>
                <Row className='mb-1'>
                    <GridHeader
                        gridEntities='Jurisdictions'
                        deleteButtonId='deleteJurisdictionButton'
                        disableDelete={!deleteEnabled}
                        onDeleteClick={handleDeleteClick}
                        addButtonId='addJurisdictionButton'
                        onAddClick={handleNew}
                        addTooltipTarget={'addJurisdictionButton'}
                        deleteTooltipTarget={'deleteJurisdictionButton'}
                        tooltipEntity={'Jurisdiction'}
                    />
                </Row>
                <Row className='mb-1'>
                    <Col>
                            <DataGrid
                                rows={props.jurisdictions.toJS().map(x => { return { id: x.jurisdictionId, ...x } })}
                                checkboxSelection
                                onRowDoubleClick={handleSelect}
                                onRowSelectionModelChange={handleSelectionChanged}
                                autoHeight={true}
                                rowHeight={35}
                                initialState={{
                                    pagination: { paginationModel: { pageSize: 25 } },
                            }}

                                columns={[
                                    {
                                        headerName: 'State',
                                        field: 'state',
                                        flex: 2,
                                    },
                                    {
                                        headerName: 'County',
                                        field: 'county',
                                        flex: 2,
                                    },
                                    {
                                        headerName: 'City',
                                        field: 'city',
                                        flex: 2,
                                    },
                                    {
                                        headerName: 'Name',
                                        field: 'name',
                                        flex: 2,
                                    }
                                ]}
                                sx={{
                                    backgroundColor: 'white'
                                }}
                                getRowClassName={(params) => 'grid-row'}/>
                    </Col>
                </Row>
                <DeleteConfirmation
                    title={`Delete Jurisdiction`}
                    onDelete={handleDelete}
                    onToggle={handleDeleteConfirmationToggle}
                    toDelete={deleteConfirmationState.toDelete.map(x => { 
                        const state = x.state;
                        const name = x.name || '';
                        return `${state} - ${name}`;
                    })}
                    isOpen={deleteConfirmationState.display}
                />
            </Container>
        );
    }

function mapStateToProps(state, ownProps) {
    return {
        jurisdictions: state.Jurisdictions
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators({ ...actions }, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(Jurisdictions);